import React from 'react'
import { Button, SxProps, Theme } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import HomeIcon from '@mui/icons-material/Home'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

export type NavigationButtonVariant = 'back' | 'home'

interface PortalNavigationButtonProps {
  variant: NavigationButtonVariant
  onClick: () => void
  sx?: SxProps<Theme>
}

export const PortalNavigationButton: React.FC<PortalNavigationButtonProps> = ({
  variant,
  onClick,
  sx,
}) => {
  const icon = variant === 'back' ? <ArrowBackIcon /> : <HomeIcon />
  const text = variant === 'back' ? '管理ポータルに戻る' : 'メイン画面に戻る'
  const bottom = variant === 'back' ? 24 : 84

  return (
    <Button
      variant="outlined"
      startIcon={icon}
      onClick={onClick}
      sx={[navigationButtonStyles(bottom), ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {text}
    </Button>
  )
}

const navigationButtonStyles = (bottom: number): SxProps<Theme> => ({
  position: 'fixed',
  bottom,
  left: 24,
  zIndex: 1000,
  color: colorTokens.blue[600],
  borderWidth: '1px',
  borderColor: colorTokens.blue[600],
  px: 2.5,
  py: 1.5,
  backgroundColor: 'rgba(25, 118, 210, 0.04)',
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    borderColor: colorTokens.blue[700],
  },
  transition: 'all 0.2s ease-in-out',
})
